import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { DateTimeComponent } from "../date-time/date-time.component";
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-header',
  imports: [CommonModule, DateTimeComponent, TranslateModule, RouterModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  @Input() locales: string[] = [];
  @Input() selectedLang: string = '';
  dropdownOpen = false;
  animate = false;

  constructor(private elementRef: ElementRef){}

  @Output() selectLang = new EventEmitter<string>();

  get languages(){
    return this.locales.map(lang => lang.split('-')[0]);
  }


  changeLanguage(langIndex: number){
    this.selectLang.emit(this.locales[langIndex]);
  }

  toggleDropdown() {
    if (!this.dropdownOpen) {
      this.dropdownOpen = true;
      this.animate = true;
    } else {
      this.animate = false;
      setTimeout(() => {
        this.dropdownOpen = false;
      }, 500);
    }
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    if (!this.elementRef.nativeElement.querySelector('#langue-selection').contains(event.target)) {
      this.animate = false;
      setTimeout(() => {
        this.dropdownOpen = false;
      }, 500);
    }
  }


}
